import type { ComponentSchema } from '../../../../../schema-types'

/** Pathok account: overview, orders, profile and addresses pages with side navigation. Keys follow lightings-1. */
export const schema: ComponentSchema = {
  type: 'account',
  label: 'Account',
  description: 'Signed-in shopper area: overview, orders, profile and saved addresses.',
  supportedPages: ['account', 'orders', 'profile', 'addresses'],
  variants: [{ id: 'v1', label: 'Side navigation' }],
  commonFields: [
    { key: 'title', label: 'Overview title', type: 'string', default: 'My account' },
    { key: 'tabOverviewLabel', label: 'Overview label', type: 'string', default: 'Overview' },
    { key: 'tabOrdersLabel', label: 'Orders label', type: 'string', default: 'Orders' },
    { key: 'tabDetailsLabel', label: 'Profile label', type: 'string', default: 'Profile' },
    { key: 'tabAddressesLabel', label: 'Addresses label', type: 'string', default: 'Addresses' },
    { key: 'signOutLabel', label: 'Sign out label', type: 'string', default: 'Sign out' },
  ],
}
